export class SetAuthFormEmail {
  static readonly type = '[AuthForm] Set auth form email';
  constructor(public email: string | null) {}
}
